module.exports = __webpack_public_path__ + "static/media/Actualidad.7e2af271.png";